import '@unocss/reset/tailwind.css'
import { plugin as pinceau } from 'pinceau/runtime'
import utils from '#build/pinceau/utils'

export default defineNuxtPlugin(async (nuxtApp) => {
              // Setup plugin
              nuxtApp.vueApp.use(pinceau, { colorSchemeMode: 'class', utils })
            })